import React from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Close';

/**
 * The list-filter search box.
 *
 * Full width on a phone, fixed on desktop, with a clear button once there is
 * something to clear — otherwise the only way to reset a filter on a touch
 * device is to hold backspace.
 */
export const SearchField: React.FC<{
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  /** Desktop width. Always 100% below `sm`. */
  width?: number;
}> = ({ value, onChange, placeholder = 'Search', width = 320 }) => (
  <TextField
    size="small"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    aria-label={placeholder}
    sx={{ width: { xs: '100%', sm: width } }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
        </InputAdornment>
      ),
      endAdornment: value ? (
        <InputAdornment position="end">
          <IconButton
            size="small"
            aria-label="Clear search"
            onClick={() => onChange('')}
            edge="end"
          >
            <ClearIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </InputAdornment>
      ) : undefined,
    }}
  />
);
